import type { SVGProps } from 'react';
export const IconSocialsDzen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 2C16 2 16.4741 12.08 17.96 14.04C19.4459 16 30 16 30 16C30 16 19.581 16.6259 17.96 17.96C16.339 19.2941 16 30 16 30C16 30 15.1764 19.4163 13.48 17.96C11.7835 16.5037 2 16 2 16C2 16 11.4706 15.363 13.48 14.04C15.4894 12.717 16 2 16 2Z"
      fill="currentColor"
    />
  </svg>
);
